export default __webpack_public_path__ + "static/media/deals_page_icon.352d5e37.svg";